import {ReactComponent as PdfIcon} from "../img/icon/pdf.svg";
import {displayFilename, isPdfFilename, performDownloadS3} from "../js/util";

export const S3Attachment = ({s3identifier, signedUrl}) => {

    const fileName = displayFilename(s3identifier);
    const isPdf = isPdfFilename(s3identifier);

    const content = <>
        {isPdf && <PdfIcon className="attachment-icon" aria-hidden="true"/>}
        {!isPdf && signedUrl && <img src={signedUrl} alt={fileName}/>}
        <span className="attachment-name">{fileName}</span>
    </>;

    if (!signedUrl) {
        return <span className={`attachment attachment-loading ${isPdf ? "attachment-pdf" : "attachment-image"}`}>
            {content}
        </span>;
    }

    return <a className={`attachment ${isPdf ? "attachment-pdf" : "attachment-image"}`} onClick={(e) => {
            e.preventDefault();
            performDownloadS3(signedUrl);
        }} href={signedUrl}>
            {content}
        </a>;
}
